export default __webpack_public_path__ + "static/media/Private_Equity_20230510.74c81eab.pdf";